module.exports = __webpack_public_path__ + "static/img/text-banner.34fc300d.png";